import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "order-item__article" };
const _hoisted_2 = { class: "order-item__name" };
const _hoisted_3 = { class: "order-item__identifiers" };
const _hoisted_4 = {
    key: 0,
    class: "order-item__identifier"
};
const _hoisted_5 = {
    key: 1,
    class: "order-item__identifier"
};
const _hoisted_6 = { class: "order-item__taxCategory" };
const _hoisted_7 = {
    key: 0,
    class: "order-item__image"
};
const _hoisted_8 = ["src", "alt"];
const _hoisted_9 = { class: "order-item__quantity" };
const _hoisted_10 = { class: "order-item__quantity-unit" };
const _hoisted_11 = { key: 0 };
const _hoisted_12 = {
    key: 1,
    class: "order-item__unit-price"
};
const _hoisted_13 = { class: "order-item__quantity" };
const _hoisted_14 = { class: "order-item__quantity-unit" };
const _hoisted_15 = {
    key: 0,
    class: "order-item__unit-price"
};
const _hoisted_16 = { class: "order-item__quantity" };
const _hoisted_17 = { class: "order-item__quantity" };
const _hoisted_18 = { class: "order-item__confirmation" };
const _hoisted_19 = { class: "order-item__quantity-input" };
const _hoisted_20 = ["disabled"];
import { computed, ref } from 'vue';
import Icon from "@astina/paloma-common-ui/src/components/Icon.vue";
import NumberInput from "@astina/paloma-common-ui/src/components/NumberInput.vue";
import { formatCHF } from "@/utils/currency";
export default /*@__PURE__*/ _defineComponent({
    __name: 'VensoOrderItem',
    props: {
        item: {},
        noticeItem: {},
        receiptItem: {},
        currency: {},
        locked: { type: Boolean }
    },
    emits: ['updateQuantity', 'removeItem'],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const currentQuantity = computed(() => props.noticeItem?.quantity ?? props.item?.quantity ?? 0);
        const quantityUpdate = ref(null);
        const orderedQuantity = computed(() => props.item?.quantity ?? '-');
        // value shown in the input field
        const inputQuantity = computed(() => {
            if (quantityUpdate.value !== null) {
                return quantityUpdate.value;
            }
            return currentQuantity.value;
        });
        const unsavedChanges = computed(() => quantityUpdate.value !== null && !saved.value);
        const saved = ref(false);
        function onQuantityUpdate(notifiedQuantity) {
            if (notifiedQuantity === currentQuantity.value) {
                quantityUpdate.value = null;
                return;
            }
            saved.value = false;
            quantityUpdate.value = notifiedQuantity;
        }
        function confirm() {
            if (quantityUpdate.value === null) {
                quantityUpdate.value = currentQuantity.value;
            }
            emit('updateQuantity', quantityUpdate.value);
            saved.value = true;
        }
        function removeItem() {
            emit('removeItem');
        }
        const taxRate = computed(() => {
            const rate = props.item?.taxRate ?? props.noticeItem?.taxRate;
            if (!rate) {
                return 'n.a.';
            }
            return formatCHF(Number(rate) * 100) + '%';
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("tr", {
                class: _normalizeClass(["order-item", {
                        'order-item--notified': __props.noticeItem,
                        'order-info--unsaved': unsavedChanges.value,
                        'order-item--notified-partially': __props.noticeItem && __props.item && __props.noticeItem.quantity < __props.item.quantity
                    }])
            }, [
                _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createTextVNode(_toDisplayString(__props.item?.article?.internalProductName || __props.noticeItem?.description) + " ", 1),
                            (!__props.item && !__props.locked)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    onClick: _withModifiers(removeItem, ["prevent"]),
                                    href: "",
                                    class: "button button--light button--small button--icon"
                                }, [
                                    _createVNode(Icon, { name: "delete" })
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        _cache[1] || (_cache[1] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_3, [
                            (__props.item?.article.gtin)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('venso_article.gtin_short')) + ":\n                        " + _toDisplayString(__props.item.article.gtin), 1))
                                : _createCommentVNode("", true),
                            _cache[0] || (_cache[0] = _createTextVNode()),
                            (__props.item?.article.supplierArticleNumber)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('venso_article.supplierArticleNumber_short')) + ":\n                        " + _toDisplayString(__props.item.article.supplierArticleNumber), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _cache[2] || (_cache[2] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('venso_order_item.tax')) + " " + _toDisplayString(taxRate.value), 1)
                    ])
                ]),
                _cache[6] || (_cache[6] = _createTextVNode()),
                _createElementVNode("td", null, [
                    (__props.item?.article.imageUri)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createElementVNode("img", {
                                src: __props.item?.article.imageUri,
                                alt: __props.item?.article?.internalProductName
                            }, null, 8, _hoisted_8)
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _cache[7] || (_cache[7] = _createTextVNode()),
                _createElementVNode("td", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                        (__props.item)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(__props.currency) + " " + _toDisplayString(_unref(formatCHF)(__props.item?.basePrice)), 1))
                            : _createCommentVNode("", true),
                        _cache[3] || (_cache[3] = _createTextVNode()),
                        (__props.item)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.$t('venso_order_item.per_unit', { unit: _ctx.$t(`VensoUnit.${__props.item.baseUnit}`) })), 1))
                            : _createCommentVNode("", true)
                    ])
                ]),
                _cache[8] || (_cache[8] = _createTextVNode()),
                _createElementVNode("td", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", null, _toDisplayString(__props.currency) + " " + _toDisplayString(_unref(formatCHF)(__props.item?.unitPrice ?? __props.noticeItem?.unitPrice)), 1),
                        _cache[4] || (_cache[4] = _createTextVNode()),
                        (__props.item)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.$t('venso_order_item.per_unit', {
                                unit: `${_ctx.$t(`VensoUnit.${__props.item.unit}`)} ${__props.item.article.variableConversionFactor ? _ctx.$t('venso_order_item.approx_at') : _ctx.$t('venso_order_item.at')} ${Number(__props.item.article.priceUnitPerOrderUnitFactor).toString()} ${_ctx.$t(`VensoUnit.${__props.item.article.priceUnit}`)}`
                            })), 1))
                            : _createCommentVNode("", true)
                    ])
                ]),
                _cache[9] || (_cache[9] = _createTextVNode()),
                _createElementVNode("td", _hoisted_16, _toDisplayString(__props.currency) + " " + _toDisplayString(_unref(formatCHF)(__props.item?.positionTotal ?? __props.noticeItem?.positionTotal)), 1),
                _cache[10] || (_cache[10] = _createTextVNode()),
                _createElementVNode("td", _hoisted_17, _toDisplayString(orderedQuantity.value) + " " + _toDisplayString(__props.item ? _ctx.$t(`VensoUnit.${__props.item.unit}`) : ''), 1),
                _cache[11] || (_cache[11] = _createTextVNode()),
                _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                            _createVNode(NumberInput, {
                                value: inputQuantity.value,
                                onChange: onQuantityUpdate,
                                min: 0,
                                disabled: __props.locked
                            }, null, 8, ["value", "disabled"])
                        ]),
                        _cache[5] || (_cache[5] = _createTextVNode()),
                        _createElementVNode("button", {
                            onClick: _withModifiers(confirm, ["prevent"]),
                            class: "button button--outline button--icon button--small",
                            disabled: __props.locked
                        }, [
                            _createVNode(Icon, {
                                name: unsavedChanges.value ? 'save' : 'check'
                            }, null, 8, ["name"])
                        ], 8, _hoisted_20)
                    ])
                ]),
                _cache[12] || (_cache[12] = _createTextVNode()),
                (__props.receiptItem)
                    ? (_openBlock(), _createElementBlock("td", {
                        key: 0,
                        class: _normalizeClass(["order-item__quantity", { 'order-item__quantity-mismatch': orderedQuantity.value !== __props.receiptItem.receivedQuantity }])
                    }, _toDisplayString(__props.receiptItem.receivedQuantity) + " " + _toDisplayString(__props.item ? _ctx.$t(`VensoUnit.${__props.item.unit}`) : ''), 3))
                    : _createCommentVNode("", true)
            ], 2));
        };
    }
});
